import empty from './mocks/empty.json';
import getUserData from './mocks/getUserData.json';
import ownerFirstLogin from './mocks/ownerFirstLogin.json';
import updateSubUser from './mocks/updateSubUser.json';
import updatePayment from './mocks/updatePayment.json';
import getBillingInfo from './mocks/getBillingInfo.json';
import applyDiscount from './mocks/applyDiscount.json';
import applyAccountCode from './mocks/applyAccountCode.json';
import publishBoilerplate from './mocks/publishBoilerplate.json';
import getBoilerplates from './mocks/getBoilerplates.json';
import buildNewSite from './mocks/buildNewSite.json';
import importSiteFromFile from './mocks/importSiteFromFile.json';
import fetchFormSubmissions from './mocks/fetchFormSubmissions.json';
import transferDomain from './mocks/transferDomain.json';
import purchaseNewDomain from './mocks/purchaseNewDomain.json';
import searchDomainAvailability from './mocks/searchDomainAvailability.json';
import touchDomainRecord from './mocks/touchDomainRecord.json';
import checkPurchasedStatus from './mocks/checkPurchasedStatus.json';
import checkNameServers from './mocks/checkNameServers.json';
import checkDomainExpiry from './mocks/checkDomainExpiry.json';
import getDomainStatus from './mocks/getDomainStatus.json';
import copyRecycledDropletAsset from './mocks/copyRecycledDropletAsset.json';
import moveToOwnerBucket from './mocks/moveToOwnerBucket.json';
import fetchUserFiles from './mocks/fetchUserFiles.json';
import deleteSubUser from './mocks/deleteSubUser.json';
import getUserDevices from './mocks/getUserDevices.json';
import getSecretKey from './mocks/getSecretKey.json';
import getSiteOrders from './mocks/getSiteOrders.json';
import createStripeAccount from './mocks/createStripeAccount';
import getStripeConnectAccount from './mocks/getStripeConnectAccount';
import getPaymentIntentStatus from './mocks/getPaymentIntentStatus';
import updateShippingAddress from './mocks/updateShippingAddress';
import getShippingOptions from './mocks/getShippingOptions';
import changeSitePlan from './mocks/changeSitePlan';
import getDynamicItem from './mocks/getDynamicItem';
import getForecast from './mocks/getForecast';
import restoreWebsite from './mocks/restoreWebsite';
import getBackups from './mocks/getBackups';
import getSupportTicket from './mocks/getSupportTicket';
import getTicketUsers from './mocks/getTicketUsers';
import getSupportTickets from './mocks/getSupportTickets';
import getRawWebsite from './mocks/getRawWebsite';
import goLiveSite from './mocks/goLiveSite';
import updateSiteTypes from './mocks/updateSiteTypes';
import hydrateWebsites from './mocks/hydrateWebsites';
import hydrateWebsiteData from './mocks/hydrateWebsiteData';

export default {
  getUserData,
  ownerFirstLogin,
  updateSubUser,
  updatePayment,
  getBillingInfo,
  applyDiscount,
  applyAccountCode,
  publishBoilerplate,
  getBoilerplates,
  buildNewSite,
  importSiteFromFile,
  fetchFormSubmissions,
  transferDomain,
  purchaseNewDomain,
  searchDomainAvailability,
  touchDomainRecord,
  checkPurchasedStatus,
  checkNameServers,
  checkDomainExpiry,
  getDomainStatus,
  copyRecycledDropletAsset,
  moveToOwnerBucket,
  fetchUserFiles,
  deleteSubUser,
  getUserDevices,
  getSecretKey,
  getSiteOrders,
  createStripeAccount,
  getStripeConnectAccount,
  getPaymentIntentStatus,
  updateShippingAddress,
  getShippingOptions,
  changeSitePlan,
  getDynamicItem,
  getForecast,
  restoreWebsite,
  getBackups,
  getSupportTicket,
  getTicketUsers,
  getSupportTickets,
  goLiveSite,
  getRawWebsite,
  updateSiteTypes,
  hydrateWebsites,
  hydrateWebsiteData,
  closeSupportTicket: empty,
  createSupportTicket: empty,
  closeTicket: empty,
  submitTicketComment: empty,
  updateItem: empty,
  setupTrialWatchers: empty,
  reportError: empty,
  trackEvent: empty,
  sendFeedback: empty,
  cancelAccount: empty,
  saveAlerts: empty,
  setUpFirstLoginData: empty,
  updateSubUserAttrs: empty,
  createSubUser: empty,
  deleteBoilerplate: empty,
  submitBoilerplate: empty,
  deleteWebsite: empty,
  updateSiteAttr: empty,
  updatePageAttr: empty,
  suspendSite: empty,
  savePageItem: empty,
  addPageItem: empty,
  deletePageItem: empty,
  updateSiteMap: empty,
  publishDraft: empty,
  callBuilder: empty,
  queueDomainInstall: empty,
  updateAutoRenew: empty,
  deleteDomain: empty,
  renewDomain: empty,
  deleteFormSubmission: empty,
  fetchSiteThumbnail: empty,
  deleteUserFile: empty,
  emptyEntireFolder: empty,
  checkUserFile: empty,
  disableAccount: empty,
  forgetDevice: empty,
  signoutAllDevices: empty,
  setSecretKey: empty,
  getShippingLabel: empty,
  updateOrder: empty,
  deleteOrder: empty,
  updateUser: empty,
  mapUserIdentity: empty,
};



// WEBPACK FOOTER //
// ./src/payloads/aws/lambda/functions.js